module.exports = __webpack_public_path__ + "img/logo.33e8fbb4.png";